const midias = (state = [], action) => {
    switch (action.type) {
      case 'MIDIAS':
      return {
          type: "MIDIAS",
          midiaid: action.midiaid
        }
      default:
        return state
    }
  }
  
  export default midias